import { createLocalTranscriptStore } from "../localTranscriptStore";

/**
 * D-ID transcript buffer.
 *
 * D-ID's API can create a chat and send messages, but exposes no endpoint that
 * returns one chat's messages — only an agent-wide, asynchronous, zipped log
 * export that is purged after 7 days. So the transcript cannot be pulled back
 * the way it is for HeyGen and Tavus. Instead the session frame observes the
 * SDK's message events and appends each completed turn here, and the session
 * adapter reads them out at end of session in the shared normalized shape.
 */
const store = createLocalTranscriptStore();

export const startTranscript = store.startTranscript;
export const appendTranscriptTurn = store.appendTranscriptTurn;
export const readTranscript = store.readTranscript;
export const clearTranscript = store.clearTranscript;
